import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Fn from './libs/Fn.js';

export function header() {
  // アンカーリンク（標準スクロール）
  const headerHeight = 0; // 必要に応じて調整
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      event.preventDefault();
      const href = anchor.getAttribute('href');
      if (!href || href === '#') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        const target = document.querySelector(href);
        if (target) {
          const offsetTop = target.offsetTop - headerHeight;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
      }
    });
  });

  // メガメニュー / パネル開閉
  const hamClick = document.querySelector('.js-header-button');
  const overlay = document.querySelector('.js-overlay');

  const closeMenu = () => {
    hamClick.classList.remove('is-active');
    overlay.classList.remove('is-active');
    document.querySelector('.js-header-menu').classList.remove('is-active');
    hamClick.setAttribute('aria-expanded', 'false');
    hamClick.setAttribute('aria-label', 'メニューを開く');
    Fn.fixedBody();
  };

  hamClick.addEventListener('click', () => {
    hamClick.classList.toggle('is-active');
    overlay.classList.toggle('is-active');
    document.querySelector('.js-header-menu').classList.toggle('is-active');
    const isExpanded = hamClick.getAttribute('aria-expanded') === 'true';
    hamClick.setAttribute('aria-expanded', !isExpanded);
    hamClick.setAttribute(
      'aria-label',
      !isExpanded ? 'メニューを閉じる' : 'メニューを開く'
    );
    Fn.fixedBody();
  });

  overlay.addEventListener('click', closeMenu);
}
